module.exports = __webpack_public_path__ + "static/media/in.98c56717.svg";